//services
import { PS } from "../../service/PeopleSearch.Service";

//components
// @ts-ignore
import SimpleBar from 'simplebar-react';
import { LoadingSpinner } from "thrive-components";
import ContactButton from "./ContactButton";

//interfaces
import { IUser } from "../../interfaces";
export interface IPeopleSearchResultsProps {
    countMessage : string,
    searchResults : IUser[];
    isLoading?: boolean,
    isLoadingMore?: boolean,
    infiniteScrollRef: React.MutableRefObject<null>
}



export function PeopleSearchResults({countMessage, searchResults, isLoading, isLoadingMore, infiniteScrollRef}: Readonly<IPeopleSearchResultsProps>) {    
    
    return (
        <div id='people-search-results'>
            {isLoading
                ?   <div className="spinner-container">
                        <LoadingSpinner size={20} />
                    </div>
                :   <>
                        <div className="results-count">
                            {countMessage}
                        </div>      
                        
                        <SimpleBar style={{ maxHeight: `calc(100dvh - 240px)` }}>
                            <ul className="results-container">
                                {searchResults.map((contact: IUser, index: number) => <li key={`${contact.id}${index}`} >
                                        <ContactButton 
                                            onClickContact={() =>{PS.handleClickContact(contact)}} 
                                            profileImageUrl={contact.profilePicture.uri} 
                                            displayName={contact.displayName}
                                            jobRole={contact.jobRole}
                                            department={contact.department}                        
                                        />
                                    </li>)
                                }
                            </ul>
                            
                            <div data-testid="infinite-scroll" ref={infiniteScrollRef} />
                            
                            {isLoadingMore &&
                                <div className="spinner-container">
                                    <LoadingSpinner size={20} />
                                </div>
                            }
                        </SimpleBar>
                    </> 
            }  
        </div>
    );
};

export default PeopleSearchResults; 